<li
  *ngIf="event$ | async as event"
  class="mx-0 row w-100 border-bottom pt-3 mt-1 pb-3 mb-1 align-items-end"
>
  <div
    class="px-0 my-0 col-8 pe-1"
    [class.col-md-8]="thumbnailImageUrl$ | async"
  >
    <div class="subhead pb-1" *ngIf="event$ | async as event">
      <ng-container *ngIf="displayText$ | async as displayText">
        <span
          [ngClass]="displayTextClass$ | async"
          [textContent]="displayText"
          data-test="event-status-date-text"
        >
        </span>
        <span *ngIf="!!displayText" [textContent]="', '"></span>
      </ng-container>
      <time
        floDisplayDate
        [date]="event.startDate"
        [endDate]="event.endDate"
        [variant]="event.displayDateVariant"
        [isTbd]="event.live_event?.start_time_tbd"
        class="fw-normal text-800 subhead"
        data-test="event-status-date-date"
      ></time>
      <span
        class="flo-footnote"
        *ngIf="event.is_geoblocked"
        data-test="event-status-date-geoblock-notice"
        [textContent]="'- Unavailable in your area'"
      ></span>
    </div>
    <ng-container *ngIf="isNextGenEventHub === true">
      <a
        class="my-0 h3 bold-font color-800 hover-text-primary"
        floAnalytics
        [name]="event.short_title"
        target="_top"
        href="{{siteUrl | async}}/nextgen{{event.slug_uri}}"
        [analyticsProperties]="analytics$ | async"
        data-test="event-list-item-link"
        [textContent]="event.short_title"
      >
      </a>
    </ng-container>
    <ng-container *ngIf="!isNextGenEventHub">
      <a
        class="my-0 h3 bold-font color-800 hover-text-primary"
        [routerLink]="event.slug_uri"
        floAnalytics
        [name]="event.short_title"
        [analyticsProperties]="analytics$ | async"
        data-test="event-list-item-link"
        [textContent]="event.short_title"
      ></a>
    </ng-container>
    <div
      class="subhead pb-2"
      *ngIf="event.sponsor"
      data-test="event-list-item-supporter"
      [textContent]="'Sponsored By ' + event.sponsor.title"
    ></div>
    <div class="d-flex flex-row justify-content-between mt-2">
      <div class="subhead p-0 m-0 text-500">
        <a
          class="subhead text-500 hover-text-primary"
          *ngIf="event.drill_through_link as drillThroughLink"
          floAnalytics
          data-test="event-list-item-drill-through-link"
          [routerLink]="drillThroughLink.slug_uri"
          [textContent]="drillThroughLink.name"
        ></a>
        <span
          *ngIf="event.partner && event.drill_through_link"
          [textContent]="', '"
        ></span>
        <a
          class="subhead text-500 hover-text-primary"
          floAnalytics
          data-test="event-list-item-partner-link"
          *ngIf="event.partner"
          [routerLink]="event.partner.slug_uri"
          [textContent]="event.partner.title"
        ></a>
      </div>
    </div>
  </div>
  <ng-container
    *ngIf="{
      routerLink: routerLink$ | async,
      analyticsProperties: analyticsProperties$ | async,
      thumbnail: thumbnailImageUrl$ | async,
      name: name$ | async,
      linkText: linkText$ | async
    } as details"
  >
    <div class="px-0 my-0 col-4 d-none d-md-flex justify-content-end">
      <ng-container *ngIf="!!details.thumbnail; else nonLiveEvent">
        <a
          [routerLink]="details.routerLink"
          floAnalytics
          tagName="Link"
          [name]="details.name"
          [analyticsProperties]="details.analyticsProperties"
        >
          <div class="position-relative">
            <img
              [src]="details.thumbnail | floImage: 149 | async"
              class="img-fluid rounded"
            />
            <i
              class="position-absolute center-x center-y z-index-min d-flex pointer-events-none"
              floSvg="vid_play"
              title="play video"
            ></i>
            <div class="video-overlay rounded"></div>
          </div>
        </a>
      </ng-container>
      <ng-template #nonLiveEvent>
        <a
          class="subhead p-0"
          [class.d-md-none]="details.thumbnail"
          [class.resume-button]="pausedSubscription$ | async"
          floAnalytics
          tagName="Link"
          [name]="details.name"
          [routerLink]="details.routerLink"
          [analyticsProperties]="details.analyticsProperties"
          data-test="event-status-link"
        >
          {{ details.linkText }}
        </a>
      </ng-template>
    </div>
    <div class="pxs-0 my-0 col-4 d-flex d-md-none justify-content-end">
      <a
        class="subhead p-0"
        [class.d-md-none]="details.thumbnail"
        floAnalytics
        tagName="Link"
        [name]="details.name"
        [routerLink]="details.routerLink"
        [analyticsProperties]="details.analyticsProperties"
        data-test="event-status-link"
      >
        {{ details.linkText }}
      </a>
    </div>
  </ng-container>
</li>
